
import Vue from 'vue';
import ResultMessage from '@/components/ResultMessage/index.vue';
import { getFinancialByTerritory, GetFinancialParams } from '@/services/territory/get-financial-by-territory';
import { getPixTxId } from '@/services/pix/get-pix-txid';
import { getPix } from '@/services/pix/get-pix';
import ticket from '@/services/tickets/get-tickets-total';
import getTerritoryByAgentDocumentService, {
  TerritoryStatus,
} from '@/services/territory/get-territory-by-agent-document';
import {
  removeMaskDocument,
} from '@/utils';
import Table from '@/components/TableAdapter/index.vue';
import { Wrapper } from './styles';

export enum TicketStatusData {
  PENDING = 'pending',
  PAYED = 'payed',
  CANCELLED = 'cancelled',
  LATE = 'late',
  SETTLED = 'settled'
}

export default Vue.extend({
  components: {
    Wrapper, Table, ResultMessage,
  },
  data() {
    return {

      loading: true,
      territoriesArray: [] as any,
      userLoged: JSON.parse(sessionStorage.getItem('userLogged') as string),
      headers: [
        { key: 'name', value: 'Nome', isOrder: true },
        { key: 'paymentMethods', value: 'Forma de pagamento', tag: true },
        { key: 'penaltyInstallments', value: 'Parcelas' },
        { key: 'trafficTicket', value: 'Valor da multa indenizatória' },
        { key: 'status', value: 'Status', tag: true },
      ] as any[],
      data: [] as any,
      size: -1,
      alterfix: 0,
      tickets: [{}] as any,
      txId: '',
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    ticketsD(): any[] {
      return this.tickets.map((ticket: any) => ({
        status: this.getTicketStatus(ticket.status),
        name: ticket.agents[0].name,
        id: ticket.cdterritory,
        trafficTicket: this.formatNumberToBrl(ticket.ticketInfo.totalAmount),
        penaltyInstallments: ticket.ticketInfo.totalInstallments,
        paymentMethods: 'Boleto',
        type: 'Financial',
      }));
    },
  },
  methods: {
    formatNumberToBrl(value: number) {
      return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    async getTerritory(page = 1, pageSize = 1000) {
      const formattedValue = removeMaskDocument(this.userLoged.stDocument);
      this.territoriesArray = await getTerritoryByAgentDocumentService(
        formattedValue,
        '',
        TerritoryStatus.provisional,
        false,
      );
      this.territoriesArray.forEach((element) => {
        const params: GetFinancialParams = {
          page,
          pageSize,
          cdTerritory: element.id,
        };
        getPixTxId(element.id, this.userLoged.company.stKey).then((responseTxid) => {
          this.txId = responseTxid[0]?.txId;
          if (responseTxid.length > 0) {
            getPix(this.txId).then((respData) => {
              this.tickets.push({
                status: this.getTicketStatus(respData.status),
                name: element.name,
                id: respData.txid.replace('PAGAMENTOPIX', ''),
                trafficTicket: this.formatNumberToBrl(parseInt(respData.valor.original, 10)),
                penaltyInstallments: '1',
                paymentMethods: 'PIX',
                type: 'FinancialProdutor',
              });
            });
          }
        });
        getFinancialByTerritory(params).then((e) => {
          if (e.hasErrors) {
            this.data = [];
            this.loading = false;
            return;
          }
          const paramsTicket: any = {
            cdTerritory: e.results[0]?.cdterritory,
          };
          ticket(paramsTicket);
          ticket(paramsTicket).then((resp) => {
            this.size += e.results.length;
            if (e.results.length > 0) {
              this.tickets.push({
                status: resp.objectResult[0].paymentPayed.toString() === e?.results[0].ticketInfo.totalInstallments.toString()
                  ? 'Quitado' : this.getTicketStatus(e.results[0].status || []) || [],
                name: element.name,
                id: e?.results[0]?.cdterritory || [],
                trafficTicket: this.formatNumberToBrl(e?.results[0].ticketInfo.totalAmount || []),
                penaltyInstallments: `${resp.objectResult[0].paymentPayed}/${e?.results[0].ticketInfo.totalInstallments}` || [],
                paymentMethods: 'Boleto',
                type: 'FinancialProdutor',
              });
            }
            this.pagination.total = 10;
            this.loading = false;
          });
        });
      });
    },
    getTicketStatus(status: string) {
      if (status !== null) {
        const ticketStatus = {
          [TicketStatusData.PAYED]: 'Quitado',
          [TicketStatusData.LATE]: 'Em atraso',
        };
        if (status === 'ATIVA') {
          return 'Em dia';
        } if (status === 'CONCLUIDA') {
          return 'Quitado';
        }
        return ticketStatus[status] || 'Em dia';
      }
      return 'Em dia';
    },
  },
  async created() {
    await this.getTerritory();
    this.tickets.pop();
  },
  watch: {
    size() {
      this.alterfix = this.size;
    },
  },
});
